module.exports = __webpack_public_path__ + "img/Slice7-min.baf749c1.png";